<template>
  <vx-card no-shadow>
    <vs-popup fullscreen :title="popupTitle" :active.sync="popupActive" v-if="currentTemplate != null">
      <b>Report Details</b>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <br />
          <ejs-multiselect :fields="parameterFieldsReports" v-model="currentTemplate.type" :dataSource="useReportsList"
            showClearButton="false" popupHeight="400px" mode="CheckBox" enableGroupCheckBox="false"
            showDropDownIcon="true" allowFiltering="true" filterType="contains" filterBarPlaceholder="Search"
            showSelectAll="false" placeholder="Report Type" maximumSelectionLength="1"></ejs-multiselect>
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input v-validate="'required|min:5'" data-vv-validate-on="blur" name="label" label-placeholder="Label"
            v-model="currentTemplate.label" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3 w-half">
          <vs-input v-validate="'required|min:3'" data-vv-validate-on="blur" name="remarks" label-placeholder="Remarks"
            v-model="currentTemplate.remarks" class="w-full" />
        </div>
      </div>
      <hr />
      <b>Configuration</b>
      <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Assign Units by Group</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect :fields="parameterFieldsGroups" v-model="currentTemplate.groups" :dataSource="groupData"
            showClearButton="false" popupHeight="400px" mode="CheckBox" enableGroupCheckBox="false"
            showDropDownIcon="true" allowFiltering="true" filterType="contains" filterBarPlaceholder="Search"
            showSelectAll="false" placeholder="Assign Units"></ejs-multiselect>
        </div>
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Assign User</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect :fields="parameterFieldsUsers" v-model="currentTemplate.users" :dataSource="userData"
            showClearButton="false" popupHeight="400px" mode="CheckBox" enableGroupCheckBox="false"
            showDropDownIcon="true" allowFiltering="true" filterType="contains" filterBarPlaceholder="Search"
            showSelectAll="false" placeholder="Assign Users"></ejs-multiselect>
        </div>
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Format</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect :fields="parameterFieldsStandard" v-model="currentTemplate.formats"
            :dataSource="parameterOptionsFormat" showClearButton="false" popupHeight="400px" mode="CheckBox"
            enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true" filterType="contains"
            filterBarPlaceholder="Search" showSelectAll="false" placeholder="Select Format"></ejs-multiselect>
        </div>
        <br />
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">Customize Report</div>
        <div class="vx-col md:w-1/3 w-half">
          <ejs-multiselect :fields="parameterFieldsSelection" v-model="currentTemplate.fields"
            :dataSource="parameterFieldsOptions" showClearButton="false" popupHeight="400px" mode="CheckBox"
            enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true" filterType="contains"
            filterBarPlaceholder="Search" showSelectAll="false" placeholder="Select Fields"></ejs-multiselect>
        </div>
      </div>
      <br />

      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <b>Additional Configurations</b>
        </div>
        <br />
      </div>
      <div class="vx-row" v-if="
        currentTemplate &&
        (currentTemplate.type[0] == 'Maintenance Log' ||
          currentTemplate.type[0] == 'Maintenance Cost' ||
          currentTemplate.type[0] == 'Tire Cost Analysis')
      ">
        <div class="vx-col md:w-1/4 w-half">Status of Records</div>
        <div class="vx-col md:w-1/4 w-half">
          <v-select :options="['Upcoming', 'Delayed', 'Completed']" placeholder="Status of Records"
            v-model="currentTemplate.configuration.fleetMTTypes2" :multiple="true" :clearable="false"></v-select>
        </div>
        <div class="vx-col md:w-1/4 w-half">Types of Records</div>
        <div class="vx-col md:w-1/4 w-half">
          <v-select :options="['Document', 'Service', 'Tire']" placeholder="Types of Records"
            v-model="currentTemplate.configuration.fleetMTTypes" :multiple="true" :clearable="false"></v-select>
        </div>
      </div>
      <div class="vx-row" v-if="
        currentTemplate &&
        (currentTemplate.type[0] == 'History' ||
          currentTemplate.type[0] == 'Temperature')
      ">
        <div class="vx-col md:w-1/5 w-half">Time Interval</div>
        <div class="vx-col md:w-1/5 w-half">
          <vs-input-number v-model="currentTemplate.configuration.interval" label="Minutes" :step="1" />
        </div>
        <div class="vx-col md:w-1/5 w-half">Speed Filter</div>
        <div class="vx-col md:w-1/5 w-half">
          <v-select :options="['>=', '<=', '=']" v-model="currentTemplate.configuration.speedType" />
        </div>
        <div class="vx-col md:w-1/5 w-half">
          <vs-input v-model="currentTemplate.configuration.speedLimit" />
        </div>
      </div>
      <div v-if="currentTemplate && currentTemplate.type[0] == 'Summary'">
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">Idling Timer</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.idleTimer" label="minutes" :step="10" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Parking Timer</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.parkTimer" label="minutes" :step="10" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Trip Timer</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.tripTimer" label="minutes" :step="10" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">Idling Wastage</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.idlingWastagePct" label="Pct %" :step="10" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Fuel Price (RM)</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.idlingWastagePrice" label="Price RM" :step="1" />
          </div>
          <div class="vx-col md:w-1/6 w-half">
            Idling Wastage Liter per Hour
          </div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.idlingWastageLtr" label="Liter/hour" :step="1" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">Include Fuel Analysis</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-switch v-model="currentTemplate.configuration.includeFuelAnalysis">
              <span slot="yes">YES</span>
              <span slot="no">NO</span>
            </vs-switch>
          </div>
        </div>
      </div>

      <div class="vx-row" v-if="currentTemplate && currentTemplate.type[0] == 'Alarm'">
        <div class="vx-col md:w-1/6 w-half">Overspeeding Timer</div>
        <div class="vx-col md:w-1/6 w-half">
          <vs-input-number v-model="currentTemplate.configuration.speedTimer" label="seconds" :step="30" />
        </div>
        <div class="vx-col md:w-1/6 w-half">Overspeeding Limit</div>
        <div class="vx-col md:w-1/6 w-half">
          <vs-input-number v-model="currentTemplate.configuration.speedLimit" label="kph" :step="5" />
        </div>
        <div class="vx-col md:w-1/6 w-half">Idling Timer</div>
        <div class="vx-col md:w-1/6 w-half">
          <vs-input-number v-model="currentTemplate.configuration.idleTimer" label="minutes" :step="10" />
        </div>
      </div>
      <div class="vx-row" v-if="currentTemplate && currentTemplate.type[0] == 'Input'">
        <div class="vx-col md:w-1/4 w-half">Input Timer</div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-input-number v-model="currentTemplate.configuration.inputTimer" label="seconds" :step="30" />
        </div>
        <div class="vx-col md:w-1/4 w-half">PTO Analysis</div>
        <div class="vx-col md:w-1/4 w-half">
          <vs-switch v-model="currentTemplate.configuration.agriAnalysis">
            <span slot="yes">YES</span>
            <span slot="no">NO</span>
          </vs-switch>
        </div>
      </div>
      <div v-if="currentTemplate && currentTemplate.type[0] == 'Fuel'">
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">Fuel Price (RM)</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input v-model="currentTemplate.configuration.refuelPrice" type="number" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Refuel Volume</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.refuelVolume" label="Litres" :step="10" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Refuel Timer</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.refuelTimer" label="Minutes" :step="5" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-half">Siphon Volume</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.siphonVolume" label="Litres" :step="10" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Siphon Timer</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.siphonTimer" label="Minutes" :step="5" />
          </div>
          <div class="vx-col md:w-1/6 w-half">Refuel Weight Density</div>
          <div class="vx-col md:w-1/6 w-half">
            <vs-input-number v-model="currentTemplate.configuration.refuelWeightDensity" label="kg/Litre" />
          </div>
        </div>
      </div>
      <hr />
      <br />
      <b>Datetime Settings</b>
      <br /><br />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-half">Frequency</div>
        <div class="vx-col md:w-1/4 w-half">
          <ejs-multiselect :fields="parameterFieldsStandard" v-model="currentTemplate.settings.frequency"
            :dataSource="parameterOptionsFrequency" showClearButton="false" popupHeight="400px" mode="CheckBox"
            enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true" filterType="contains"
            filterBarPlaceholder="Search" showSelectAll="false" placeholder="Select When to Receive"
            maximumSelectionLength="1"></ejs-multiselect>
        </div>
      </div>
      <div class="vx-row" v-if="
        currentTemplate && currentTemplate.settings.frequency[0] == 'week'
      ">
        <div class="vx-col md:w-1/4 w-half">Day Select</div>
        <div class="vx-col md:w-1/4 w-half">
          <ejs-multiselect :fields="parameterFieldsStandard" v-model="currentTemplate.settings.week_day"
            :dataSource="parameterOptionsWeekly" showClearButton="false" popupHeight="400px" mode="CheckBox"
            enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true" filterType="contains"
            filterBarPlaceholder="Search" showSelectAll="false" placeholder="Select Day to Receive"
            maximumSelectionLength="1"></ejs-multiselect>
        </div>
      </div>
      <div class="vx-row" v-if="
        currentTemplate && currentTemplate.settings.frequency[0] == 'month'
      ">
        <div class="vx-col md:w-1/4 w-half">Day Select</div>
        <div class="vx-col md:w-1/4 w-half">
          <ejs-multiselect :fields="parameterFieldsStandard" v-model="currentTemplate.settings.month_date"
            :dataSource="parameterOptionsMonthly" showClearButton="false" popupHeight="400px" mode="CheckBox"
            enableGroupCheckBox="false" showDropDownIcon="true" allowFiltering="true" filterType="contains"
            filterBarPlaceholder="Search" showSelectAll="false" placeholder="Select Day to Receive"
            maximumSelectionLength="1"></ejs-multiselect>
        </div>
      </div>
      <br />
      </div>
      <hr />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/8 w-half">
          <b>Notification Channels</b>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-plus"
            @click="addContact('add')">Add Channel</vs-button>
        </div>
        <div class="vx-col md:w-1/8 w-half">
          <vs-button color="primary" size="small" type="border" icon-pack="feather" icon="icon-plus"
            @click="showChannels()">Select from Existing Channels</vs-button>
        </div>
      </div>
      <br />
      <div v-if="showExistingChannels">
        <div class="vx-row">
          <div class="vx-col md:w-1/8 w-half">
            <b>Current Channels</b>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-2/3 w-full">
            <vs-table stripe :data="existingChannels" max-height="500">
              <template slot="thead">
                <vs-th width="5%">No.</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Detail</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <span>
                      <b>{{ indextr + 1 }}.</b></span>
                  </vs-td>
                  <vs-td>
                    {{ tr.type }}
                  </vs-td>
                  <vs-td>
                    {{ tr.detail }}
                  </vs-td>
                  <vs-td>
                    {{ tr.remark }}
                  </vs-td>
                  <vs-td>
                    <vs-button color="success" type="border" icon-pack="feather" icon="icon-check"
                      @click="addContactExisting(indextr)">Add</vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="vx-col md:w-1/3 w-full"></div>
          <br />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-2/3 w-full">
          <vs-table stripe :data="currentTemplate.channels" max-height="500">
            <template slot="thead">
              <vs-th width="5%">No.</vs-th>
              <vs-th>Type</vs-th>
              <vs-th>Detail</vs-th>
              <vs-th>Remarks</vs-th>
              <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span>
                    <b>{{ indextr + 1 }}.</b></span>
                </vs-td>
                <vs-td>
                  <v-select placeholder="Select Type" clearable="false" :options="['Telegram', 'Email', 'SMS']"
                    v-model="currentTemplate.channels[indextr].type" />
                </vs-td>
                <vs-td>
                  <vs-input v-model="currentTemplate.channels[indextr].detail" label-placeholder="Details"
                    class="w-full" />
                </vs-td>
                <vs-td>
                  <vs-input v-model="currentTemplate.channels[indextr].remark" label-placeholder="Remarks"
                    class="w-full" />
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="border" icon-pack="feather" icon="icon-trash"
                    @click="removeContact(indextr)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div class="vx-col md:w-1/3 w-full"></div>
        <br />
      </div>
      <hr />
      <br />
      <vs-button v-if="mode == 'add'" color="primary" type="filled" icon-pack="feather" icon="icon-plus"
        @click="postData('add')">Add New Automated Report</vs-button>
      <br />
      <div v-if="mode == 'update'">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-half">
            Created Report: <b>{{ currentTemplate.create_time }}</b>
          </div>
          <div class="vx-col md:w-1/4 w-half" v-if="currentTemplate.update_time != null">
            Last Updated : <b>{{ currentTemplate.update_time }}</b>
          </div>
        </div>
        <br />
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-half">
            Sample Notification Title :
            <b>{{ currentTemplate.label + ' - ' + ' - Monthly Report' }}</b>
          </div>
          <div class="vx-col md:w-2/3 w-half">
            Sample Notification Message :
            <b>{{ 'Your report is ready. Click to Download from Link / Attachment' }}</b>
          </div>
        </div>
        <br /><br />
        <div class="vx-row" v-if="
          userInfo.userRole == 'Administrator' ||
          currentTemplate.createdBy == userInfo.uid ||
          userInfo.access.actions.includes('reports-staff')
        ">
          <div class="vx-col md:w-1/4 w-half">
            <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-pen" @click="postData('update')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('reports-update') ||
                userInfo.access.actions.includes('reports-staff')
              ">Update Automated Report</vs-button>
          </div>
          <div class="vx-col md:w-1/4 w-half">
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="postData('delete')"
              v-if="
                userInfo.userRole == 'Administrator' ||
                userInfo.access.actions.includes('reports-delete') ||
                userInfo.access.actions.includes('reports-staff')
              ">Delete Automated Report</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-progress indeterminate color="primary" v-if="isLoading == true"></vs-progress>

    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-half">
        <vs-button size="small" @click="addTemplate" v-if="
          userInfo.userRole == 'Administrator' ||
          userInfo.access.actions.includes('reports-add') ||
          userInfo.access.actions.includes('reports-staff')
        ">Add New Automated Report</vs-button>
      </div>
    </div>

    <br />

    <ejs-grid :dataSource="templateData" :allowExcelExport="true" :allowPdfExport="true" :toolbarClick="toolbarClick"
      :allowTextWrap="true" height="60vh" gridLines="Both" :filterSettings="filterOptions" :allowPaging="true"
      :searchSettings="searchOptions" :toolbar="toolbarOptions" ref="reportTemplateGrid" id="reportTemplateGrid"
      :pageSettings="pageSettings" :showColumnChooser="true" :allowSorting="true" :allowMultiSorting="true"
      :allowFiltering="true">
      <e-columns>
        <e-column field="no" headerText="No." textAlign="Left" width="100"></e-column>
        <e-column field="label" headerText="Label" textAlign="Left"></e-column>
        <e-column field="remarks" headerText="Remarks" textAlign="Left"></e-column>
        <e-column field="update_time" headerText="Updated" textAlign="Left" width="200"></e-column>
        <e-column headerText="Manage" textAlign="Left" :template="cTemplate" width="120"></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate5.vue';
import vSelect from 'vue-select';
import axios from '@/axios.js';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { reportsList } from '../../live/reports/config/reportsList';
import * as reportMeta from '../../live/reports/index';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
    flatPickr,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      initial: true,
      isLoading: false,
      mode: 'add',
      showExistingChannels: false,
      existingChannels: [],
      popupActive: false,
      popupTitle: 'Add New Automated Report',
      templateData: [],
      userData: [
        {
          userGroup: 'Default',
          name: `${JSON.parse(localStorage.getItem('userInfo')).displayName
            } | ${JSON.parse(localStorage.getItem('userInfo')).username}`,
          id: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      parameterFieldsUsers: { groupBy: 'userGroup', text: 'name', value: 'id' },
      parameterFieldsSelection: {
        groupBy: 'reportGroup',
        text: 'name',
        value: 'id',
      },
      parameterFieldsOptions: [],
      parameterOptionsFrequency: [
        {
          label: 'Daily',
          val: 'day',
        },
        {
          label: 'Weekly',
          val: 'week',
        },
        {
          label: 'Monthly',
          val: 'month',
        },
      ],
      parameterOptionsWeekly: [
        {
          label: 'Monday',
          val: 1,
        },
        {
          label: 'Tuesday',
          val: 2,
        },
        {
          label: 'Wednesday',
          val: 3,
        },
        {
          label: 'Thursday',
          val: 4,
        },
        {
          label: 'Friday',
          val: 5,
        },
        {
          label: 'Saturday',
          val: 6,
        },
        {
          label: 'Sunday',
          val: 7,
        },
      ],
      parameterOptionsMonthly: [
        {
          label: 'Last Calendar Day of Month',
          val: -1,
        },
        {
          label: '1st',
          val: 1,
        },
        {
          label: '2nd',
          val: 2,
        },
        {
          label: '3rd',
          val: 3,
        },
        {
          label: '4th',
          val: 4,
        },
        {
          label: '5th',
          val: 5,
        },
        {
          label: '6th',
          val: 6,
        },
        {
          label: '7th',
          val: 7,
        },
        {
          label: '8th',
          val: 8,
        },
        {
          label: '9th',
          val: 9,
        },
        {
          label: '10th',
          val: 10,
        },
        {
          label: '11th',
          val: 11,
        },
        {
          label: '12th',
          val: 12,
        },
        {
          label: '13th',
          val: 13,
        },
        {
          label: '14th',
          val: 14,
        },
        {
          label: '15th',
          val: 15,
        },
        {
          label: '16th',
          val: 16,
        },
        {
          label: '17th',
          val: 17,
        },
        {
          label: '18th',
          val: 18,
        },
        {
          label: '19th',
          val: 19,
        },
        {
          label: '20th',
          val: 20,
        },
        {
          label: '21st',
          val: 21,
        },
        {
          label: '22nd',
          val: 22,
        },
        {
          label: '23rd',
          val: 23,
        },
        {
          label: '24th',
          val: 24,
        },
        {
          label: '25th',
          val: 25,
        },
        {
          label: '26th',
          val: 26,
        },
        {
          label: '27th',
          val: 27,
        },
        {
          label: '28th',
          val: 28,
        },
        {
          label: '29th',
          val: 29,
        },
        {
          label: '30th',
          val: 30,
        },
        {
          label: '31st',
          val: 31,
        },
      ],
      parameterFieldsGroups: {
        groupBy: 'groupGroup',
        text: 'name',
        value: 'id',
      },
      groupData: [{ groupGroup: 'Default', name: 'All Units Assigned', id: 0 }],
      currentTemplate: null,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      cTemplate() {
        return { template: columntempVue };
      },
      configdateTimePicker: {
        enableTime: true,
        enableMinutes: false,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
      },
      reportConfiguration:
        JSON.parse(localStorage.getItem('reportConfiguration')) || null,
      parameterFieldsReports: { text: 'label', value: 'label' },
      parameterFieldsStandard: { text: 'label', value: 'val' },
      parameterOptionsFormat: [
        {
          val: 'excel',
          label: 'Excel',
        },
        {
          val: 'pdf',
          label: 'PDF',
        },
      ],
      configuration: null,
    };
  },
  computed: {
    useReportsList() {
      let result = [...this.userInfo.access.reports];
      let newResult = [];
      let found = [];
      // merge the selection
      const getItemLabel = (item) =>
        item.label ? item.label.toLowerCase() : item.name;
      result.forEach((main) => {
        const foundObject = reportsList.find(
          (item) => getItemLabel(item) === main.toLowerCase(),
        );
        if (foundObject) {
          found.push(foundObject.name);
        }
      });
      reportsList.forEach((item) => {
        newResult.push({
          label: item.label
            ? item.label
            : `${item.name.charAt(0).toUpperCase()}${item.name.slice(1)}`,
          val: item.name,
        });
        if (!found.includes(item.name)) {
          result.push(
            item.label
              ? item.label
              : `${item.name.charAt(0).toUpperCase()}${item.name.slice(1)}`,
          );
        }
      });

      return newResult;
    },
  },
  methods: {
    findIndexByProperty(arr, prop, value) {
      return arr.findIndex((obj) => obj[prop] === value);
    },
    showChannels() {
      this.showExistingChannels = !this.showExistingChannels;
    },
    removeContact(index) {
      this.currentTemplate.channels.splice(index, 1);
      this.$vs.notify({
        time: 4000,
        text: 'Removed Channel',
        color: 'success',
      });
    },
    addContact() {
      this.currentTemplate.channels.push({ type: '', detail: '', remark: '' });
      this.$vs.notify({
        time: 4000,
        text: 'Added Empty Channel',
        color: 'success',
      });
    },
    addContactExisting(index) {
      this.currentTemplate.channels.push({
        type: this.existingChannels[index].type,
        detail: this.existingChannels[index].detail,
        remark: this.existingChannels[index].remark,
      });
      this.$vs.notify({
        time: 4000,
        text: 'Added Existing Channel',
        color: 'success',
      });
    },
    validateTemplate() {
      const self = this;
      return new Promise((resolve, reject) => {
        if (self.currentTemplate.type.length < 1) {
          reject('Report Type is mandatory. Select to continue.');
        }
        if (self.currentTemplate.label.length < 5) {
          reject('Label field is mandatory. Minimum 5 characters.');
        }
        if (self.currentTemplate.groups.length < 1) {
          reject(
            'Unit assignment is mandatory. Select minimum 1 group of units to continue.',
          );
        }
        if (self.currentTemplate.users.length < 1) {
          reject(
            'User assignment is mandatory. Select minimum 1 user to continue.',
          );
        }
        if (self.currentTemplate.formats.length < 1) {
          reject('Report Format Type is mandatory. Select to continue.');
        }
        if (self.currentTemplate.fields.length < 1) {
          reject(
            'Report Field Customize is mandatory. Select at least 1 to continue.',
          );
        }
        if (self.currentTemplate.settings.frequency.length < 1) {
          reject(
            'Frequency to receive Reports Field is mandatory. Select to continue.',
          );
        }
        if (
          self.currentTemplate.settings.frequency[0] == 'week' &&
          self.currentTemplate.settings.week_day.length < 1
        ) {
          reject('Cutoff Day is mandatory. Select to continue.');
        }
        if (
          self.currentTemplate.settings.frequency[0] == 'month' &&
          self.currentTemplate.settings.month_date.length < 1
        ) {
          reject('Cutoff Date is mandatory. Select to continue.');
        }
        resolve(true);
      });
    },
    addTemplate() {
      const self = this;
      self.mode = 'add';
      self.popupTitle = 'Add New Automated Report';
      self.currentTemplate = {
        type: [],
        label: '',
        remarks: '',
        configuration: self.configuration,
        fields: [],
        settings: {
          frequency: [],
          week_day: [],
          month_date: [],
        },
        users: [],
        groups: [],
        formats: [],
        channels: [],
        createdType: 'Self Created',
        createdBy: self.userInfo.uid
      };
      self.parameterFieldsOptions = [];
      self.popupActive = true;
    },
    editTemplate(data) {
      const self = this;
      self.mode = 'update';
      self.popupTitle = `Update Report ${data.label}`;
      self.currentTemplate = {
        type: JSON.parse(data.type),
        label: data.label,
        remarks: data.remarks,
        configuration: JSON.parse(data.configuration),
        fields: JSON.parse(data.fields),
        settings: JSON.parse(data.settings),
        users: JSON.parse(data.users),
        groups: JSON.parse(data.groups),
        formats: JSON.parse(data.formats),
        channels: JSON.parse(data.channels),
        createdBy: data.createdBy,
        id: data.id,
        create_time: data.create_time,
        update_time: data.update_time,
      };
      self.popupActive = true;
    },
    getData() {
      const self = this;
      let staffAccess;
      axios
        .post(
          `https://api.igeotechgps.com/api-reports/get-reports/${self.userInfo.uid}/${self.userInfo.userRole}`,
          {
            adtlAccess: self.userInfo.access.actions.includes('reports-staff'),
          },
        )
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.templateData = response.data.templateData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData2() {
      const self = this;
      let uid = self.userInfo.uid;
      if (self.userInfo.access.actions.includes('reports-staff')) {
        uid = 1;
      }
      self.$http
        .get(`admin/users/main/${uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            response.data.userData.forEach(function (element) {
              self.userData.push({
                id: element.id,
                name: element.username,
                userGroup: 'User Created',
              });
            });
            response.data.groupData.forEach(function (element) {
              self.groupData.push({
                id: element.id,
                name: element.name,
                groupGroup: 'User Created',
              });
            });
            axios
              .post('https://api.igeotechgps.com/api-events/get-channels', {
                userIds: self.userData,
              })
              .then(function (response) {
                if (response.status == 200 && response.data.success) {
                  self.existingChannels = response.data.existingChannels;
                } else if (response.data.error) {
                } else {
                }
              });
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) { });
    },
    postData(type) {
      const self = this;
      let url;
      let successText;
      let successTitle;
      let failureText;
      if (type == 'add') {
        url = 'https://api.igeotechgps.com/api-reports/add-reports';
        successText =
          'Note: Newly added reports could take upto 2 hours to activate';
        successTitle = 'Added New Report';
        failureText =
          'Could not add report, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'update') {
        url = 'https://api.igeotechgps.com/api-reports/update-reports';
        successText =
          'Note: Updated reports configurations could take upto 2 hours to activate';
        successTitle = 'Updated Report';
        failureText =
          'Could not update report, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
      }
      if (type == 'delete') {
        url = 'https://api.igeotechgps.com/api-reports/delete-reports';
        successText =
          'Note: Deleted report could take upto 2 hours to de-activate';
        successTitle = 'Deleted Report';
        failureText =
          'Could not delete report, pls try again later OR Contact Igeotechgps Account Manager for assistance.';
        const text =
          'Report deletion action is PERMANENT & IRREVERSIBLE. Continue? ';
        if (confirm(text) == false) {
          return;
        }
      }

      if (type == 'add' || type == 'update') {
        self
          .validateTemplate()
          .then((result) => {
            self.confirmPostData(url, successText, successTitle, failureText);
          })
          .catch((error) => {
            self.$vs.notify({
              time: 5000,
              title: error,
              color: 'warning',
            });
          });
      } else {
        self.confirmPostData(url, successText, successTitle, failureText);
      }
    },
    confirmPostData(url, successText, successTitle, failureText) {
      const self = this;
      axios
        .post(url, {
          userInfo: self.userInfo,
          currentTemplate: self.currentTemplate,
        })
        .then(function (response) {
          self.popupActive = false;
          if (response.status == 200 && response.data.success) {
            self.$vs.notify({
              time: 10000,
              text: successText,
              title: successTitle,
              color: 'success',
            });
            self.getData();
            self.getData2();
          } else {
            self.$vs.notify({
              time: 8000,
              title: failureText,
              color: 'warning',
            });
            if (response.data.error) {
            } else {
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toolbarClick(args) {
      if (args.item.id === 'reportTemplateGrid_excelexport') {
        var exportProperties = {
          fileName: 'Automated Reports - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.reportTemplateGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'reportTemplateGrid_pdfexport') {
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Automated Reports - Listing.pdf',
        };
        this.$refs.reportTemplateGrid.pdfExport(exportProperties);
      }
    },
  },
  watch: {
    currentTemplate: {
      handler() {
        var self = this;
        if (!self.currentTemplate) return;
        if (self.currentTemplate.type.length == 0) return;
        if (self.currentTemplate.type.length == 1) {
          const allReports = self.useReportsList;
          const type = self.currentTemplate.type[0];
          const typeIndex = self.findIndexByProperty(allReports, 'label', type);
          self.parameterFieldsOptions = [];
          if (typeIndex != -1) {
            const typeVal = allReports[typeIndex].val;
            const fixedMeta = reportMeta[typeVal]();
            var fmIndex = 0;
            var cmIndex = 0;
            fixedMeta.forEach((item) => {
              const content = item.view.content;
              cmIndex = 0;
              content.forEach((contentItem) => {
                if (contentItem.header != 'Actions') {
                  self.parameterFieldsOptions.push({
                    reportGroup: `${type} - ${item.label}`,
                    name: `${contentItem.header}`,
                    id: `${fmIndex}_${cmIndex}_${contentItem.field}`,
                  });
                }
                cmIndex++;
              });
              fmIndex++;
            });
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    const self = this;
    self.getData();
    self.getData2();
    self.initial = false;
    if (self.reportConfiguration) {
      self.configuration = self.reportConfiguration;
    } else {
      self.configuration = {
        fleetMTTypes: ['Document', 'Service', 'Tire'],
        fleetMTTypes2: ['Upcoming', 'Delayed', 'Completed'],
        idleTimer: 0,
        parkTimer: 0,
        tripTimer: 0,
        interval: 0,
        speedType: '',
        speedLimit: 90,
        speedTimer: 60,
        refuelPrice: 2.15,
        refuelVolume: 10,
        refuelTimer: 60,
        siphonVolume: 10,
        siphonTimer: 15,
        showHidden: false,
        inputTimer: 0,
        agriAnalysis: false,
        refuelWeightDensity: 1.0,
        idlingWastagePct: 80,
        idlingWastageLtr: 3,
        idlingWastagePrice: 2.15,
        includeFuelAnalysis: false,
      };
    }
  },
};
</script>
